// Defaults align to current IAB US section IDs.
const USSTATE_DEFAULT_SECTION_IDS = {
    va: 9,
    co: 10,
    ct: 11,
    ut: 12,
};
let RUNTIME = {};
export function setUsStateConfig(cfg) {
    RUNTIME = { ...RUNTIME, ...cfg };
}
export function getUsStateSectionId(s) {
    return (RUNTIME.ids && RUNTIME.ids[s]) || USSTATE_DEFAULT_SECTION_IDS[s];
}
export function statesEnabled() {
    if (typeof RUNTIME.enabled === 'boolean')
        return RUNTIME.enabled;
    try {
        const v = process.env?.['GPP_US_STATES_ENABLE'];
        // Default ON to preserve current behavior and tests; set to '0' to disable.
        return v === undefined ? true : v === '1';
    }
    catch {
        return true;
    }
}
// Backwards-compatible export (for code that imports constant names)
export const USSTATE_SECTION_IDS = USSTATE_DEFAULT_SECTION_IDS;
//# sourceMappingURL=usstate-schema.js.map